<template>
  <app-carousel
    v-if="isInitialized && carouselItems.length"
    :items="carouselItems"
    :settings="settings"
    :thinIcon="true"
    :iconColor="variant === 'dark' ? '#000' : '#b9bfc9'"
    class="products-carousel"
    :class="[variantClass]"
  >
    <template #default="{ model }">
      <carousel-entry
        :title="model.title"
        :link="model.link"
        :categoryTitle="model.categoryTitle"
        :categoryLink="model.categoryLink"
        :image="model.image"
        :buttonText="model.buttonText"
      />
    </template>
  </app-carousel>
</template>
<script>
import AppCarousel from '@/components/common/AppCarousel.vue'
import CarouselEntry from '@/components/common/CarouselEntry.vue'

export default {
  components: {
    AppCarousel,
    CarouselEntry,
  },
  props: {
    carouselItems: {
      type: Array,
      required: true,
    },
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'dark'].includes(value),
    },
  },
  data() {
    return {
      settings: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        navigation: {
          prevEl: '',
          nextEl: '',
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1250: {
            slidesPerView: 3,
          },
        },
      },
      isInitialized: false,
    }
  },
  computed: {
    variantClass() {
      return this.variant === 'primary' ? '' : `products-carousel--variant-${this.variant}`
    },
  },
  created() {
    const randomId = Date.now().toString() + (Math.random() * 10000).toFixed()
    this.settings.navigation.prevEl = `.app-carousel__button-prev-${randomId}`
    this.settings.navigation.nextEl = `.app-carousel__button-next-${randomId}`
    this.isInitialized = true
  },
}
</script>
